import {SetState} from "../../util/FormHandlers";
import React from "react";
import {Grid} from "@mui/material";
import {HierarchyNode} from "../../util/EmployeeHierarchy";
import {filterSerializer} from "../../util/FilterSerializer";
import {TextSearchFilter} from "../../components/filter-fields/TextSearchFilter";
import {ClearFilterButton} from "../../components/filter-fields/ClearFilterButton";
import {NeighbourhoodsFilter} from "../../components/filter-fields/NeighbourhoodsFilter";
import {INeighbourhood} from "../../api/Model";
import {andFilter, Filter, filterNeighbourhoods, filterText} from "../../util/FilterUtil";

export interface CompanyTreemapFilterForm {
    neighbourhoods: INeighbourhood[],
    search: string,
}

const emptyCompanyTreemapFilterForm = {
    neighbourhoods: [],
    search: '',
};
export const companyTreemapFilterFormSerializer = (allNeighbourhoods: INeighbourhood[]) => filterSerializer<CompanyTreemapFilterForm>(
    emptyCompanyTreemapFilterForm,
    b => {
        b.neighbourhoods('neighbourhoods', allNeighbourhoods);
        b.str('search');
    }
);

export function toCompanyTreemapFilter(filter: CompanyTreemapFilterForm): Filter<HierarchyNode> {
    return andFilter<HierarchyNode>(
        filterNeighbourhoods(filter.neighbourhoods, node => node.neighbourhoods),
        filterText(filter.search, node => node.fullName),
    );
}


export function CompanyTreemapFilter({filter, setFilter, allNeighbourhoods}: {
    filter: CompanyTreemapFilterForm,
    setFilter: SetState<CompanyTreemapFilterForm>,
    allNeighbourhoods?: INeighbourhood[],
}) {
    return (
        <Grid container spacing={2} alignItems="center">
            <NeighbourhoodsFilter filter={filter} setFilter={setFilter} allNeighbourhoods={allNeighbourhoods}/>
            <TextSearchFilter filter={filter} setFilter={setFilter} property="search"/>
            <ClearFilterButton emptyFilter={emptyCompanyTreemapFilterForm} setFilter={setFilter}/>
        </Grid>
    );
}
